// extracted by mini-css-extract-plugin
export var addButton = "_47-d";
export var bullets = "_47-e";
export var compact = "_47-2";
export var container = "_47-j";
export var extendedWarrantyModal = "_47-f";
export var learn = "_47-l";
export var learnMore = "_47-g";
export var offeringOption = "_47-3";
export var offeringPrice = "_47-8";
export var offeringSubtitle = "_47-7";
export var offeringTitle = "_47-6";
export var offeringsContainer = "_47-0";
export var pdpTilesBackground = "_47-n";
export var plan = "_47-m";
export var regular = "_47-1";
export var remove = "_47-k";
export var seeDetailsIcon = "_47-i";
export var seeDetailsLink = "_47-h";
export var selectedOption = "_47-4";
export var shieldIcon = "_47-b";
export var shieldIconCompact = "_47-c";
export var subtitle = "_47-a";
export var title = "_47-9";
export var unselectedOption = "_47-5";